export default __webpack_public_path__ + "static/media/names_black.038332dd.png";